// extracted by mini-css-extract-plugin
export default {"background":"styles_background__GMxSE","hide-content":"styles_hide-content__z0BDo","layout":"styles_layout__a6U2l"};